// extracted by mini-css-extract-plugin
export default {"header":"Header_header__XoqEs","logoCont":"Header_logoCont__fd0lw","linksCont":"Header_linksCont__oNpZn","menuBtn":"Header_menuBtn__YjHO6"};